import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-048edf1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "local-github-activity" }
const _hoisted_2 = {
  key: 0,
  class: "activity-loading"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-spinner" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Loading git activity...", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "activity-error"
}
const _hoisted_7 = { class: "error-content" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Using fallback data", -1))
const _hoisted_9 = {
  key: 2,
  class: "activity-container"
}
const _hoisted_10 = { class: "github-calendar-responsive" }
const _hoisted_11 = { class: "calendar-period" }
const _hoisted_12 = { class: "github-calendar" }
const _hoisted_13 = { class: "month-labels" }
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"day-labels\" data-v-048edf1e><div class=\"day-label\" data-v-048edf1e>Mon</div><div class=\"day-label\" data-v-048edf1e></div><div class=\"day-label\" data-v-048edf1e>Wed</div><div class=\"day-label\" data-v-048edf1e></div><div class=\"day-label\" data-v-048edf1e>Fri</div><div class=\"day-label\" data-v-048edf1e></div><div class=\"day-label\" data-v-048edf1e></div></div>", 1)
const _hoisted_15 = { class: "calendar-grid calendar-grid-split" }
const _hoisted_16 = ["title", "onMouseenter"]
const _hoisted_17 = { class: "calendar-period" }
const _hoisted_18 = { class: "github-calendar" }
const _hoisted_19 = { class: "month-labels" }
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"day-labels\" data-v-048edf1e><div class=\"day-label\" data-v-048edf1e>Mon</div><div class=\"day-label\" data-v-048edf1e></div><div class=\"day-label\" data-v-048edf1e>Wed</div><div class=\"day-label\" data-v-048edf1e></div><div class=\"day-label\" data-v-048edf1e>Fri</div><div class=\"day-label\" data-v-048edf1e></div><div class=\"day-label\" data-v-048edf1e></div></div>", 1)
const _hoisted_21 = { class: "calendar-grid calendar-grid-split" }
const _hoisted_22 = ["title", "onMouseenter"]
const _hoisted_23 = { class: "github-calendar-single" }
const _hoisted_24 = { class: "github-calendar" }
const _hoisted_25 = { class: "month-labels" }
const _hoisted_26 = /*#__PURE__*/_createStaticVNode("<div class=\"day-labels\" data-v-048edf1e><div class=\"day-label\" data-v-048edf1e>Mon</div><div class=\"day-label\" data-v-048edf1e></div><div class=\"day-label\" data-v-048edf1e>Wed</div><div class=\"day-label\" data-v-048edf1e></div><div class=\"day-label\" data-v-048edf1e>Fri</div><div class=\"day-label\" data-v-048edf1e></div><div class=\"day-label\" data-v-048edf1e></div></div>", 1)
const _hoisted_27 = { class: "calendar-grid calendar-grid-full" }
const _hoisted_28 = ["title", "onMouseenter"]
const _hoisted_29 = /*#__PURE__*/_createStaticVNode("<div class=\"activity-legend\" data-v-048edf1e><span class=\"legend-text\" data-v-048edf1e>Less</span><div class=\"legend-colors\" data-v-048edf1e><div class=\"legend-square intensity-0\" data-v-048edf1e></div><div class=\"legend-square intensity-1\" data-v-048edf1e></div><div class=\"legend-square intensity-2\" data-v-048edf1e></div><div class=\"legend-square intensity-3\" data-v-048edf1e></div><div class=\"legend-square intensity-4\" data-v-048edf1e></div></div><span class=\"legend-text\" data-v-048edf1e>More</span></div>", 1)
const _hoisted_30 = {
  key: 0,
  class: "activity-stats"
}
const _hoisted_31 = { class: "stat-item" }
const _hoisted_32 = { class: "stat-value" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "stat-label" }, "contributions in the last year", -1))
const _hoisted_34 = {
  key: 4,
  class: "activity-branding"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Data from GitHub + GitLab", -1))
const _hoisted_36 = [
  _hoisted_35
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_ion_icon, {
                name: "git-branch-outline",
                class: "error-icon"
              }),
              _createElementVNode("p", null, _toDisplayString(_ctx.error), 1),
              _hoisted_8
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.monthLabels.firstHalf, (month) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `first-${month.month}`,
                        class: "month-label"
                      }, _toDisplayString(month.label), 1))
                    }), 128))
                  ]),
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calendarData.firstHalf, (day) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `first-${day.date}`,
                        class: _normalizeClass(["day-square", _ctx.getIntensityClass(day.count)]),
                        title: _ctx.getTooltip(day),
                        onMouseenter: ($event: any) => (_ctx.showTooltip($event, day)),
                        onMouseleave: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideTooltip && _ctx.hideTooltip(...args)))
                      }, null, 42, _hoisted_16))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.monthLabels.secondHalf, (month) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `second-${month.month}`,
                        class: "month-label"
                      }, _toDisplayString(month.label), 1))
                    }), 128))
                  ]),
                  _hoisted_20,
                  _createElementVNode("div", _hoisted_21, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calendarData.secondHalf, (day) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `second-${day.date}`,
                        class: _normalizeClass(["day-square", _ctx.getIntensityClass(day.count)]),
                        title: _ctx.getTooltip(day),
                        onMouseenter: ($event: any) => (_ctx.showTooltip($event, day)),
                        onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hideTooltip && _ctx.hideTooltip(...args)))
                      }, null, 42, _hoisted_22))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.monthLabels.full, (month) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `full-${month.month}`,
                      class: "month-label"
                    }, _toDisplayString(month.label), 1))
                  }), 128))
                ]),
                _hoisted_26,
                _createElementVNode("div", _hoisted_27, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calendarData.full, (day) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `full-${day.date}`,
                      class: _normalizeClass(["day-square", _ctx.getIntensityClass(day.count)]),
                      title: _ctx.getTooltip(day),
                      onMouseenter: ($event: any) => (_ctx.showTooltip($event, day)),
                      onMouseleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.hideTooltip && _ctx.hideTooltip(...args)))
                    }, null, 42, _hoisted_28))
                  }), 128))
                ])
              ])
            ]),
            _hoisted_29,
            (_ctx.stats)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.stats.totalContributions), 1),
                    _hoisted_33
                  ])
                ]))
              : _createCommentVNode("", true)
          ])),
    (_ctx.tooltip.show)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          ref: "tooltipEl",
          class: "custom-tooltip",
          style: _normalizeStyle({ left: `${_ctx.tooltip.x}px`, top: `${_ctx.tooltip.y}px` })
        }, _toDisplayString(_ctx.tooltip.text), 5))
      : _createCommentVNode("", true),
    (_ctx.showBranding)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_36))
      : _createCommentVNode("", true)
  ]))
}